import { render } from "./WelcomeBanner.vue?vue&type=template&id=4c559272&scoped=true&ts=true"
import script from "./WelcomeBanner.vue?vue&type=script&lang=ts"
export * from "./WelcomeBanner.vue?vue&type=script&lang=ts"

import "./WelcomeBanner.vue?vue&type=style&index=0&id=4c559272&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c559272"]])

export default __exports__